export default {
	'filters_text_1': 'List of Accounts',
	'filters_text_2': 'Apply',
	'filters_text_3': 'Reset',
	'filters_text_4': 'Show filters',
	'filters_text_5': 'Hide filters',
	'filters_text_6': 'Transactions',
	'filters_text_7': 'Deals',
	'filters_text_8': 'Transaction currency',
	'filters_text_9': 'Accounts',
	'filters_text_10': 'List of clients',
	'filters_text_11': 'List of deals',
	'filters_text_12': 'History',
	'filters_text_13': 'Transaction history',
};